import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyle = makeStyles(() => ({
    root: {
        position: 'relative',
        display: 'flex', 
        flexDirection: 'column', 
        color: '#fff', 
        fontFamily: 'Montserrat, sans-serif', 
        fontSize: 18, 
        borderBottom: '1px solid rgba(0,0,0,.3)', 
        width: '100%', 
        textAlign: 'center', 
        paddingTop: 20, 
        paddingBottom: 20,
        background: '#1b2039'
    },
    online: {
        position: 'absolute', 
        top: 10, 
        left: 10, 
        fontSize: 14, 
        color: '#ACACAC'
    },
    group: {
        position: 'absolute', 
        top: 10, 
        right: 10, 
        fontSize: 14, 
        color: '#3cde0b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgb(255, 255, 255, .3)',
        borderRadius: '4px',
        padding: '5px 10px',
        fontWeight: 700
    },
    wrapLogin: {
        margin: '12px 0'
    },
    wrapBlock: {
        padding: '0 20px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        columnGap: 5
    },
    w50: {
        width: '50%'
    },
    btn: {
        padding: '3px 14px',
        borderRadius: 4,
        background: '#ffc324',
        color: '#141b33',
        cursor: 'pointer',
        border: 'none',
        fontSize: 16
    },
}))

export {
    useStyle
}